import { VCard } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-cards"},[_c(VCard,[_c('div',{staticClass:"card-mark"},[_vm._v(_vm._s(_vm.counter))]),_c('div',{staticClass:"card-text"},[_vm._v(_vm._s(_vm.note))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }